import { render, staticRenderFns } from "./WaitForRedirect.vue?vue&type=template&id=75e4cfb8"
import script from "./WaitForRedirect.vue?vue&type=script&lang=js"
export * from "./WaitForRedirect.vue?vue&type=script&lang=js"
import style0 from "./WaitForRedirect.vue?vue&type=style&index=0&id=75e4cfb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports